const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/components/LoadingSpinner/index.ts';
import LoadingSpinner from './LoadingSpinner';

export default LoadingSpinner;
